export const SERVER_URL = "https://s4sportal.pukattechnology.com/";
export const X_API_KEY = "4MiWU3bPKEdweVwn";
